import React, { useEffect, useState } from 'react';
import { Card, Form, Row, Col, Select, Space, Input, Radio, Table, Button, InputNumber, message } from 'antd';
import AreasSelect from '../components/AreasSelect';
import ProductSkuModal from '../components/Checkout/ProductSkuModal';
import { checkoutMock } from '../services/checkoutService';
import MerchantInfo from '../components/Checkout/MerchantInfo';
import CheckoutInfo from '../components/Checkout/CheckoutInfo';
import ShippingLimit from '../components/Checkout/ShippingLimit';
import ProcessingFee from '../components/Checkout/ProcessingFee';
import ForwardingFee from '../components/Checkout/ForwardingFee';
import QandA from '../components/Checkout/QandA';
import { CHECKOUT_MOCK_ADDRESS } from '../common/constants';
import _ from 'lodash';
const { Option } = Select;

function Checkout(props) {
    const [form] = Form.useForm();
    const [visible, setVisible] = useState(false);
    const [skuList, setSkuList] = useState([]);
    const [merchant, setMerchant] = useState('');
    const [areas, setAreas] = useState([]);
    const [result, setResule] = useState();
    const [productId, setProductId] = useState(props?.match?.params?.id || '');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if(productId) {
            setVisible(true);
        }
    }, [productId])

    function handleSelect(data) {
        const { sku, product } = data || {}
        const list = _.cloneDeep(skuList);
        list.push({
            ...sku,
            name: product.name,
            category: product.category,
            quantity: 1,
            images: sku?.images?.length ? sku?.images : product?.images
        });
        setSkuList(list);
        setMerchant(product.merchantId);
    }

    function handleAreaChange(v, s) {
        setAreas(s)
        const zipCode = s?.[s.length - 1]?.zipCode;
        const dialingCode = s?.[0]?.dialingCode;
        if(zipCode) {
            form.setFieldsValue({zipCode});
        }
        if(dialingCode) {
            form.setFieldsValue({dialingCode});
        }
    }

    function handleProductDelete(target) {
        const list = _.cloneDeep(skuList);
        const index = list?.findIndex(item => item?.id === target?.id);
        list?.splice(index,1);
        if(!list?.length) {
            setMerchant('');
        }
        setSkuList(list);
    }

    function handleQuantityChange(target, num) {
        const list = _.cloneDeep(skuList);
        const current = list?.find(item => item?.id === target?.id);
        current.quantity = num;
        setSkuList(list);
    }

    function handleShippingChange(shipping) {
        onSubmit({
            group: {
                shippingMethod: shipping?.name
            }
        })
    }

    function setDefaultAddress(event) {
        const address = CHECKOUT_MOCK_ADDRESS?.[event?.target?.value] || {};
        form.resetFields();
        form.setFieldsValue(address);
        setAreas(address?.areas);
    }

    function onSubmit(param) {
        if(loading) return null;
        setLoading(true);
        setResule(null);
        const data = form.getFieldsValue();
        const chinaCode = ['CN', 'HK', 'MO', 'TW'];
        const params = {
            group: {
                id: merchant,
                shippingAddress: {
                    country: chinaCode?.indexOf(areas?.[0]?.code) >= 0 ? '中国' : areas?.[0]?.name,
                    countryCode: areas?.[0]?.code,
                    state: areas?.[1]?.name,
                    stateCode: areas?.[1]?.code,
                    city: areas?.[2]?.name,
                    district: areas?.[3]?.name,
                    line1: data.line1,
                    line2: data.line2,
                    phone: data.recipientPhone,
                    zipCode: data.zipCode || areas?.[3]?.zipCode,
                    dutyWarning: false,
                    identityAuth: true,
                    dialingCode: data?.dialingCode || areas?.[0]?.dialingCode,
                    firstName: data?.recipient?.slice(1),
                    lastName: data?.recipient?.slice(0, 1),
                    identification: {
                        ccIdName: data?.recipient,
                        ccIdNumber: data?.recipientIdNumber,
                        photoIdBack: 'xxx',
                        photoIdFront: 'aaa'
                    }
                },
                payerIdentity: {
                    idNumber: data.payerIdNumber,
                    firstName: data?.payer?.slice(1),
                    lastName: data?.payer?.slice(0, 1)
                },
                loyaltyPointUsage: data.loyaltyPointUsage ? {
                    apply: true,
                    appliedCents: data.loyaltyPointUsage * 100
                } : null,
                merchandiseStamps: data.merchandiseStamps ? [{
                    amount: data.merchandiseStamps * 100
                }] : null,
                coupons: data.coupon ? [{
                    amount: data.coupon * 100
                }] : null,
                paymentMethod: data.paymentMethod,
                ...param?.group
            },
            userInfo: {
                orderNumber: data.newUser,
                level: data.level,
                ...param?.userInfo
            },
            addItemReqs: skuList?.map(item => {
                return {
                    quantity: item?.quantity,
                    sku: item
                }
            })
        }

        checkoutMock(params)
        .then(res => {
            setLoading(false);
            setResule(res?.data);
            getProductCommissionRate(res?.data);
        })
        .catch(err => {
            setLoading(false);
            if (err?.response?.status === 403) {
                message.error('账户无权限');
            } else {
                message.error(err?.response?.data?.messages?.[0] || '计算失败');
            }
        })
    }

    function getProductCommissionRate(data) {
        let list = _.cloneDeep(skuList);
        const expectedCommission = data?.merchantInfo?.commissionConfigs?.minGuaranteedCommissionRate;
        const processingFeeRecord = data?.cart?.groups?.[0]?.processingFeeRecord?.itemizedRecords;
        if(expectedCommission) {
            list = list.map(item => {
                const orderItemId = `SKU-${item?.productId}-${item?.id}`;
                const processingFeeList = processingFeeRecord?.[orderItemId]?.itemized || [];
                const merchantProcessingFee = processingFeeList?.find(item => item?.type === 'PROCESSING_FEE')?.rate || 0;
                const productCommission = (expectedCommission - merchantProcessingFee) + '%';
                return {
                    ...item,
                    productCommission
                }
            })
        }
        setSkuList(list);
    }

    return (
        <Space direction="vertical" size='middle'>
            <Card title="商品信息" style={{ width: '100%' }}>
                <Form name='order-product-info' form={form}>
                    <UserInfo />
                    <RecipientInfo
                        areas={areas}
                        handleAreaChange={handleAreaChange}
                        setDefaultAddress={setDefaultAddress}
                    />
                    <ProductInfo
                        dataSource={skuList}
                        handleAddProduct={() => setVisible(true)}
                        handleProductDelete={handleProductDelete}
                        handleQuantityChange={handleQuantityChange}
                    />
                    <DiscountInfo />
                    <Row justify="center">
                        <Button type="primary" size='large' onClick={onSubmit} loading={loading}>计算</Button>
                    </Row>
                </Form>
            </Card>
            <MerchantInfo merchantInfo={result?.merchantInfo} />
            <CheckoutInfo cart={result?.cart} error={result?.orderResultErrors} />
            <ProcessingFee cart={result?.cart} />
            <ForwardingFee cart={result?.cart} forwardingFeeDetails={result?.forwardingFeeDetails?.[0]} />
            <ShippingLimit cart={result?.cart} checkedProviderResults={result?.checkedProviderResults} handleShippingChange={handleShippingChange} />
            <QandA />
            <ProductSkuModal
                visible={visible}
                merchant={merchant}
                handleSelect={handleSelect}
                onCancel={() => setVisible(false)}
                productId={productId}
            />
        </Space>
    )
}

function UserInfo() {
    return <React.Fragment>
        <Row><h6>用户信息</h6></Row>
        <Row>
            <Space size='middle'>
                <Form.Item label="会员等级" name="level" initialValue="V4">
                    <Select style={{ width: 150 }}>
                        <Option value="V0">Lv0</Option>
                        <Option value="V1">Lv1</Option>
                        <Option value="V2">Lv2</Option>
                        <Option value="V3">Lv3</Option>
                        <Option value="V4">Lv4</Option>
                        <Option value="V5">Lv5</Option>
                    </Select>
                </Form.Item>
                <Form.Item label="新用户" name="newUser" initialValue={0}>
                    <Select style={{ width: 150 }}>
                        <Option value={0}>是</Option>
                        <Option value={1}>否</Option>
                    </Select>
                </Form.Item>
            </Space>
        </Row>
    </React.Fragment>
}

function RecipientInfo(props) {
    const { setDefaultAddress, areas, handleAreaChange } = props;
    return <React.Fragment>
        <Row><h6 style={{marginTop: '20px'}}>收件信息</h6></Row>
        <Row>
            <Form.Item label="地区" name="area">
                <AreasSelect onChange={handleAreaChange} areas={areas} />
            </Form.Item>
        </Row>
        <Row>
            <Space size='middle'>
                <Form.Item label="地址1" name="line1">
                    <Input />
                </Form.Item>
                <Form.Item label="地址2" name="line2">
                    <Input />
                </Form.Item>
                <Form.Item label="邮编" name="zipCode">
                    <Input />
                </Form.Item>
            </Space>
        </Row>
        <Row>
            <Space size='middle'>
                <Form.Item label="收件人" name="recipient">
                    <Input />
                </Form.Item>
                <Form.Item label="身份证" name="recipientIdNumber">
                    <Input />
                </Form.Item>
                <Form.Item label="区号" name="dialingCode">
                    <Input style={{width: '60px'}} />
                </Form.Item>
                <Form.Item label="手机号" name="recipientPhone">
                    <Input />
                </Form.Item>
            </Space>
        </Row>
        <Row>
            <Space size='middle'>
                <Form.Item label="支付人" name="payer">
                    <Input />
                </Form.Item>
                <Form.Item label="身份证" name="payerIdNumber">
                    <Input />
                </Form.Item>
            </Space>
        </Row>
        <Row>
            <Space size='middle'>
                <div>使用默认地址</div>
                <Radio.Group buttonStyle="solid" onChange={setDefaultAddress}>
                    <Radio.Button value="CN">中国大陆</Radio.Button>
                    <Radio.Button value="HK">中国香港</Radio.Button>
                    <Radio.Button value="US">美国</Radio.Button>
                </Radio.Group>
            </Space>
        </Row>
    </React.Fragment>
}

function ProductInfo(props) {
    const { dataSource, handleProductDelete, handleQuantityChange } = props;
    const columns = [{
        title: '商品图片',
        dataIndex: 'img',
        key: 'img',
        render: (record, item) => {
            return <img src={item?.images?.[0]?.full?.url} style={{width: '100px', height: '100px', objectFit: 'contain'}} />
        }
    }, {
        title: 'itemId',
        dataIndex: 'itemId',
        key: 'itemId',
        width: '15%',
        render: (record, item) => {
            return <span style={{wordBreak: 'break-word'}}>SKU-{item?.productId}-{item?.id}</span>
        }
    }, {
        title: '商品名称',
        dataIndex: 'name',
        key: 'name'
    }, {
        title: '品牌',
        dataIndex: 'brand',
        key: 'brand'
    }, {
        title: '类目',
        dataIndex: 'category',
        key: 'category',
        width: '15%',
        render: (record) => <div style={{width: '150px'}}>{record}</div>
    }, {
        title: '规格',
        dataIndex: 'sku',
        key: 'sku',
        render: (record, item) => {
            const color = item?.color?.name;
            const size = item?.size?.name;
            const width = item?.attributes?.attributes?.width?.choices?.[0];
            return (
                <div>
                    {color && <div>color: {color}</div>}
                    {size && <div>size: {size}</div>}
                    {width && <div>width: {width}</div>}
                </div>
            )
        }
    }, {
    //     title: '商品佣金',
    //     dataIndex: 'productCommission',
    //     key: 'productCommission'
    // }, {
        title: '数量',
        dataIndex: 'quantity',
        key: 'quantity',
        render: (record, item) => {
            return <InputNumber value={record} min={1} onChange={(num) => handleQuantityChange(item, num)} />
        }
    }, {
        title: '操作',
        dataIndex: 'operation',
        key: 'operation',
        render: (record, item) => {
            return <Button onClick={() => handleProductDelete(item)}>删除</Button>
        }
    }]

    return <React.Fragment>
        <Row align='bottom'>
            <h6 style={{margin: '40px 20px 0 0'}}>商品信息</h6>
            <Button type="primary" onClick={props.handleAddProduct}>添加商品</Button>
        </Row>
        <Table
            style={{marginTop: '10px'}}
            dataSource={dataSource}
            columns={columns}
            pagination={false}
        />
    </React.Fragment>
}

function DiscountInfo() {
    return <React.Fragment>
        <Space direction="vertical">
            <h6 style={{margin: '30px 0 0 0'}}>折扣信息</h6>
            <Form.Item label="商品代金券抵扣$" name="merchandiseStamps">
                <InputNumber />
            </Form.Item>
            <Form.Item label="运费代金券抵扣$" name="coupon">
                <InputNumber />
            </Form.Item>
            <Form.Item label="积分抵扣$" name="loyaltyPointUsage">
                <InputNumber />
            </Form.Item>
            <Form.Item label="支付方式" name="paymentMethod" initialValue="ALIPAY">
                <Select>
                    <Option value="ALIPAY">支付宝</Option>
                    <Option value="HUABEI_INSTALLMENT">支付宝花呗</Option>
                    <Option value="CREDIT_CARD">信用卡</Option>
                    <Option value="UNIONPAY">银联</Option>
                    <Option value="APPLEPAY">APPLEPAY</Option>
                    <Option value="WECHATMINIPAY">微信支付</Option>
                    <Option value="FRIENDPAY">亲友付</Option>
                </Select>
            </Form.Item>
        </Space>
    </React.Fragment>
}

export default Checkout;